import React from 'react';
import { Box } from '@mui/material';
import { MainRoutes } from './MainRoutes';
import { AppbarRoutes } from './AppbarRoutes';
import { AppSidebarRoutes } from './AppSidebarRoutes';
import { useKeycloak } from '@react-keycloak/web';

const AppRoutes = () => {
  const { initialized } = useKeycloak();

  if (!initialized) return <div>Loading auth…</div>;

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <AppbarRoutes />
      <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }} mt={`68px`}>
        <AppSidebarRoutes />
        <Box
          component="main"
          sx={{
            width: '100%',
            flexGrow: 1,
          }}
        >
          <MainRoutes />
        </Box>
      </Box>
    </Box>
  );
};

export default AppRoutes;
